import * as React from "react";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProps } from "./IconConfig";
import "./style.scss";

interface IGenericIconProps {
  iconConfig: IconProps;
  showLabel?: boolean;
}

export const GenericIcon = ({ iconConfig, showLabel }: IGenericIconProps) => (
  iconConfig ?
    <>
      {showLabel && iconConfig?.label}
      <Tooltip title={iconConfig?.label}>
        <div className="icon">
          <FontAwesomeIcon icon={iconConfig?.icon} className={iconConfig?.className} />
        </div>
      </Tooltip>
    </>
    : <></>
);



// WEBPACK FOOTER //
// ./src/components/common/Icons/GenericIcon/GenericIcon.tsx